import { createFileRoute } from "@tanstack/react-router";
import { Versammlung } from "../features/shell/Versammlung";

export const Route = createFileRoute("/versammlung")({
  component: Versammlung,
});
